const state = {
    categories_marketplace_benefits: [],
    categories_type_marketplace: [],
    subcategories_marketplace: [],
    categories_marketplace: [],
    loading_marketplace: false,
    modos_marketplace:[],
    categoryM: null
};

export default state;